var siteNavigationToggle = document.getElementById('siteNavigationToggle');
var siteNavigation = document.getElementById('siteNavigation');

siteNavigationToggle.addEventListener('click', function(e) {
	if ( this.hasAttribute('aria-pressed') ) {
		this.removeAttribute('aria-pressed');
		siteNavigation.removeAttribute('aria-expanded');
	} else {
		this.setAttribute('aria-pressed', 'true');
		siteNavigation.setAttribute('aria-expanded', 'true');
	}
});
